// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xjc7x","colBig":"styles_colBig__iJono","colSmall":"styles_colSmall__26DNL"};